import { render, staticRenderFns } from "./DemoFile.vue?vue&type=template&id=41856883"
import script from "./DemoFile.vue?vue&type=script&lang=ts"
export * from "./DemoFile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports